import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import Typography from '../../typography'
import { useBreakpoint } from '../../../../hooks/breakpoint'

const Stepper = (props) => {
  const {
    steps,
    readOnly,
    ContentStep,
    sizeStep = 6,
    lineWidth = 2,
    labels,
    styleContainer
  } = props
  const { mdAndDown } = useBreakpoint()
  const [selected, setSelected] = useState(0)

  const _handleSelectStep = (index) => () => {
    setSelected(index)
  }

  const getStepLine = useCallback((index) => {
    const commonStyle = 'absolute'
    const common = { height: '50%', marginLeft: sizeStep * 2 - lineWidth / 2, width: lineWidth || 2 }

    return index
      ? selected >= index && !readOnly
        ? (
          <>
            <div
              className={`bg-red-500 ${commonStyle}`}
              style={{ top: 0, ...common }} />
            {
              index === steps.length - 1
                ? null
                : <div
                  className={`bg-red-500 ${commonStyle}`}
                  style={{ bottom: 0, ...common }} />
            }
          </>
        )
        : (
          <>
            <div
              className={` ${commonStyle} ${readOnly ? 'bg-gray-500' : 'bg-green-600'}`}
              style={{ top: 0, ...common }} />
            {
              index === steps.length - 1
                ? null
                : <div
                  className={`${commonStyle} ${readOnly ? 'bg-gray-500' : 'bg-green-600'}`}
                  style={{ bottom: 0, ...common }} />
            }
          </>
        )
      : (
        <div
          className={`${readOnly ? 'bg-gray-500' : 'bg-red-500'} ${commonStyle}`}
          style={{ bottom: 0, ...common }} />
      )
  }, [readOnly, selected, steps])

  return (
    <div className={`flex flex-col ${styleContainer || 'justify-between items-center mx-0 md:mx-4 p-4'}`}>
      {
        steps.map((course, index) => {
          return (
            <div key={`step-${index + 1}`}
              className={'w-full md:w-11/12 lg:w-9/12 relative flex flex-col items-between'} >
              <div className="flex flex-row items-center h-full">
                <div className='h-full mr-4' >
                  {
                    readOnly
                      ? (
                        <div
                          style={{ zIndex: 10, border: 'hidden', outline: 'none' }}
                          className={`relative rounded-full h-${sizeStep || 6} w-${sizeStep || 6} bg-gray-500`}
                        >
                          {
                            labels && labels.length
                              ? <Typography weight='bold' className={`absolute -top-18 -left-${sizeStep} md:-left-44 md:top-0`} >
                                {labels[index]}
                              </Typography>
                              : null
                          }
                        </div>)
                      : (
                        <button
                          onClick={_handleSelectStep(index)}
                          style={{ zIndex: 10, border: 'hidden', outline: 'none' }}
                          className={`relative rounded-full  h-${sizeStep || 6} w-${sizeStep || 6} ${selected >= index ? 'bg-red-500' : 'bg-green-600'}`}
                        >
                          {
                            labels && labels.length
                              ? <Typography weight='bold' className={`${mdAndDown ? 'hidden' : ''} absolute -top-18 -left-${sizeStep} md:-left-24 lg:-left-44 md:top-0`} >
                                {labels[index]}
                              </Typography>
                              : null
                          }
                        </button>
                      )
                  }
                  {getStepLine(index)}
                </div>
                {
                  ContentStep
                    ? <ContentStep
                      {...course}
                      header={course.title || null}
                      totalModules={course.totalModules || null}
                      title={mdAndDown
                        ? <Typography weight='bold'>
                          {labels[index]}
                        </Typography>
                        : null}
                      isFirstStep={Boolean(index === 0)}
                      isLastStep={Boolean(index === steps.length - 1)}
                      isSelected={Boolean(index === selected)} />
                    : null}
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

Stepper.propTypes = {
  steps: PropTypes.array,
  readOnly: PropTypes.bool,
  ContentStep: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]),
  sizeStep: PropTypes.number,
  lineWidth: PropTypes.number,
  labels: PropTypes.array,
  styleContainer: PropTypes.string
}

export default Stepper
